<div class="layout-container">

  <header class="board-header">
    <button class="icon-button" (click)="exitBoard()" title="Exit Game">
      <img src="assets/arrow_back.svg" alt="Back" />
    </button>
    <div class="local-player-badge">
      <span class="local-player-label">PLAYER</span>
      <span class="local-player-value">{{local_player_name()}}</span>
    </div>
  </header>

  <main class="board-main">

    @if (phase() === 'voting'){

      <div class="info-card">
        <p class="instruction-text"><strong>{{start_name()}}</strong> gives the first clue, then turns pass clockwise. If <strong>{{start_name()}}</strong> is eliminated, the next active player begins.</p>
      </div>

      <div class="word-section">
        @if (is_word_visible()){
          <div class="word-card">
              @if (word()){
                <span class="word-label">SECRET WORD</span>
                <p class="current-word">{{word()}}</p>
              }
              @else{
                <span class="word-label">YOU ARE THE</span>
                <p class="current-word impostor">impostor</p>
              }
          </div>
          <button class="action-button outline" (click)="hideWord()">Hide word</button>
        }
        @else{
          <button class="action-button outline" (click)="showWord()">Show word</button>
        }
      </div>

      <div class="players-section">
        <h3 class="section-title">Vote out a player</h3>
        <p class="instruction-text micro-text">In case of a tie, the eliminated player is chosen randomly.</p>
        <div class="players-scroll-container">
          <div class="players-list-vertical">
            @for (player of remote_player_names(); track player){
              <button class="action-button primary small" (click)="vote(player)">{{player}}</button>
            }
          </div>
        </div>
      </div>

    }

    @else if (phase() === 'waiting_for_votes'){
      <div class="waiting-state">
        <div class="loader"></div>
        <p class="waiting-text">Waiting for everyone to vote...</p>
      </div>
    }

    @else if (phase() === 'vote_result' || phase() === 'guess_result'){

      @if (!is_me_voted()){

        <div class="result-card">
          <span class="result-label">VOTED OUT</span>
          <p class="result-value">{{voted_player_name()}}</p>
          <span class="result-role" [class.impostor]="is_voted_player_impostor()">
            {{is_voted_player_impostor() ? 'Impostor' : 'Civilian'}}
          </span>
        </div>

        @if (!is_voted_player_impostor()){

          @if (is_vote_game_ended()){

            <div class="game-over-card sub-card">
              @if (is_vote_game_draw()){
                <h2 class="game-over-title" style="font-size: 1.5rem">Draw!</h2>
                <p class="game-over-desc">Only one civilian and one impostor survived.</p>
              }
              @else{
                <h2 class="game-over-title" style="font-size: 1.5rem">Impostors Won!</h2>
                <p class="game-over-desc">All civilians have been eliminated.</p>
              }
            </div>

            <button class="action-button primary large" (click)="exitBoard()">Play Again</button>

          }
          @else{
            <div class="action-area">
              <button class="action-button primary large" (click)="continueRound()">Continue to next round</button>
            </div>
          }

        }
        @else{

          @if (phase() === 'vote_result'){
            <div class="waiting-state">
              <div class="loader"></div>
              <p class="waiting-text">Waiting for the impostor to submit the guessed word...</p>
            </div>
          }

          @else if (phase() === 'guess_result'){

            @if (is_guess_correct()){
              <div class="game-over-card">
                <h2 class="game-over-title">Impostors Won!</h2>
                <p class="game-over-desc">The impostor <strong>{{voted_player_name()}}</strong> guessed the right word <strong>{{guessed_word()}}</strong>.</p>
              </div>
              <button class="action-button primary large" (click)="exitBoard()">Play Again</button>
            }
            @else{

              @if (is_guess_game_ended()){

                <div class="game-over-card sub-card">
                  @if (is_guess_game_draw()){
                    <h2 class="game-over-title" style="font-size: 1.5rem">Draw!</h2>
                    <p class="game-over-desc">The impostor <strong>{{voted_player_name()}}</strong> guessed the wrong word: <strong>{{guessed_word()}}</strong>. Only one civilian and one impostor survived.</p>
                  }
                  @else{
                    <h2 class="game-over-title" style="font-size: 1.5rem">Civilians Won!</h2>
                    <p class="game-over-desc">The impostor <strong>{{voted_player_name()}}</strong> guessed the word incorrectly: <strong>{{guessed_word()}}</strong>. All impostors have been eliminated.</p>
                  }
                </div>

                <button class="action-button primary large" (click)="exitBoard()">Play Again</button>

              }
              @else{
                <div class="info-card">
                  <p class="instruction-text">The impostor <strong>{{voted_player_name()}}</strong> guessed the word incorrectly: <strong>{{guessed_word()}}</strong>.</p>
                </div>
                <div class="action-area">
                  <button class="action-button primary large" (click)="continueRound()">Continue to next round</button>
                </div>
              }

            }

          }

        }

      }
      @else{

        @if (!is_voted_player_impostor()){

          <div class="game-over-card">
            <h2 class="game-over-title">Eliminated!</h2>
            <p class="game-over-desc">You were voted out.</p>
          </div>

          @if (is_vote_game_ended()){

            <div class="game-over-card sub-card">
              @if (is_vote_game_draw()){
                <h2 class="game-over-title" style="font-size: 1.5rem">Draw!</h2>
                <p class="game-over-desc">Only one civilian and one impostor survived.</p>
              }
              @else{
                <h2 class="game-over-title" style="font-size: 1.5rem">Impostors Won!</h2>
                <p class="game-over-desc">All civilians have been eliminated.</p>
              }
            </div>

            <button class="action-button primary large" (click)="exitBoard()">Play Again</button>

          }
          @else{
            <div class="action-area">
              <button class="action-button secondary large" (click)="exitBoard()">Exit Game</button>
            </div>
          }

        }
        @else{

          @if (phase() === 'vote_result'){

            <div class="info-card">
              <h3 class="section-title text-center">You were voted out</h3>
            </div>
            
            <div class="input-group">
              <input class="word-input" type="text" placeholder="Guess the secret word" [value]="typed_word()" (input)="onWordInput($event)" />
              <button class="action-button primary" [disabled]="!typed_word()" (click)="submitWord()">Submit</button>
            </div>

          }

          @else if (phase() === 'guess_result'){

            @if (is_guess_correct()){
              <div class="game-over-card">
                <h2 class="game-over-title">Impostors Won!</h2>
                <p class="game-over-desc">You guessed the right word: <strong>{{guessed_word()}}</strong>.</p>
              </div>
              <button class="action-button primary large" (click)="exitBoard()">Play Again</button>
            }
            @else{

              @if (is_guess_game_ended()){

                <div class="game-over-card sub-card">
                  @if (is_guess_game_draw()){
                    <h2 class="game-over-title" style="font-size: 1.5rem">Draw!</h2>
                    <p class="game-over-desc">You guessed the wrong word: <strong>{{guessed_word()}}</strong>. Only one civilian and one impostor survived.</p>
                  }
                  @else{
                    <h2 class="game-over-title" style="font-size: 1.5rem">Civilians Won!</h2>
                    <p class="game-over-desc">You guessed the word incorrectly: <strong>{{guessed_word()}}</strong>. All impostors have been eliminated.</p>
                  }
                </div>

                <button class="action-button primary large" (click)="exitBoard()">Play Again</button>

              }
              @else{
                <div class="game-over-card">
                  <h2 class="game-over-title">Eliminated!</h2>
                  <p class="game-over-desc">You guessed the word incorrectly: <strong>{{guessed_word()}}</strong>.</p>
                </div>
                <div class="action-area">
                  <button class="action-button secondary large" (click)="exitBoard()">Exit Game</button>
                </div>
              }

            }

          }

        }

      }

    }

  </main>

</div>
